module.exports = __webpack_public_path__ + "media/src/images/icon_word-aecb6150560c8e01cb9e6625c666bdc9.png";